module.exports = __webpack_public_path__ + "static/media/indicatorRpm.5d5d847a.png";